import { useCampaignList } from "features/campaigns/hooks/useCampaignList";
import { useSession } from "next-auth/client";
import { useUserCoupons } from "repositories/hooks";

interface Context {
  fortuneTellerId: number;
}

export const useCampaign = ({ fortuneTellerId }: Context) => {
  const { campaigns } = useCampaignList();
  const { validCoupons } = useUserCoupons();
  const [session] = useSession();

  const isCampaignTarget = campaigns?.some((campaign) =>
    campaign.fortuneTellers.some((ft) => ft.id === fortuneTellerId)
  );

  const coupon = validCoupons?.find((coupon) =>
    campaigns?.some((campaign) => campaign.coupon.id === coupon.couponId)
  );

  const hasCampaignCoupon = campaigns?.some((campaign) =>
    validCoupons.some((coupon) => coupon.couponId === campaign.coupon.id)
  );

  const showCampaignPromotion = session
    ? isCampaignTarget && hasCampaignCoupon
    : isCampaignTarget;

  return {
    coupon,
    showCampaignPromotion,
  };
};
